
import { Component, Vue, Prop } from 'vue-property-decorator'
import { getType } from '@/utils/cookies'
@Component({
  name: 'exTotal'
})
export default class extends Vue {
  @Prop() private type!: string
  @Prop({ required: true }) info!: any

  private sysType: any = ''
  mounted () {
    this.sysType = getType()
  }
}
